import React from "react";

import Image from "../Image";

import "./Brands.css";

export default function Brands() {
  return (
    <section className="section_3">
      <div className="div_block_1831980521447504">
        <div className="div_block_1831980521447503">
          <div className="text_block_941288239919">
            Recognized As The Greatest Brands In Education
          </div>
          <div className="div_block_1831980521447466_copy">
            <div className="edtech_award_container_copy">
              <Image
                src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/Home/best-skill.png"
                alt="award-image"
                className="ed_tech_award_img"
                width={"auto"}
                height={"auto"}
              />
              <div className="div_block_1831980521447505">
                <div className="text_block_941288239920">Recognised as</div>
                <div className="text_block_9412882466">
                  Best Tech Skilling
                  <br />
                  EdTech Company
                </div>
                <div className="text_block_941288239918">
                  by Times Business Awards in 2022
                </div>
              </div>
            </div>
            <div className="trusted_brand_image_copy">
              <Image
                src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/Home/trusted-brand.png"
                alt="award-image"
                className="trusted_brand_img"
                width={"auto"}
                height={"auto"}
              />
              <div className="trusted_brand_container">
                <div className="text_block_941288239920">Recognised as</div>
                <div className="text_block_9412882466">
                  Trusted Brand in
                  <br />
                  Education
                </div>
                <div className="text_block_941288239918">
                  by Prime Insights in 2023
                </div>
              </div>
            </div>
            <Image
              src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/Home/preferred.png"
              alt="preferred-brands"
              className="html_embed_82625_copy"
              width={"auto"}
              height={"auto"}
            />
            <Image
              src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/Home/brands-leaders.png"
              className="html_embed_82625_copy"
              alt="brands-leaders"
              width={"auto"}
              height={"auto"}
            />
          </div>
        </div>
        <div className="div_block_1831980521447501">
          <div className="div_block_1831980521447502">
            <Image
              alt="nxtwave-founders"
              src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/nxtwave-founders.png"
              className="image_8128822195"
              width={"auto"}
              height={"auto"}
            />
            <div className="text_block_941288239921">
              Nxtwave founders earn the prestigious Forbes India 30 under 30 in
              the education category for empowering Tier-2, 3 &amp; 4 college
              students
            </div>
          </div>
          <div className="div_block_1831980521447502">
            <Image
              alt="kaushal-deekshant-samaroh"
              src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/kaushal-deekshant-samaroh.png"
              className="image_8128822195"
              width={"auto"}
              height={"auto"}
            />
            <div className="text_block_941288239921">
              NxtWave Graduates Shine at the 2nd Kaushal Deekshant Samaroh, New
              Delhi Organised by the Ministry of Skill Development and
              Entrepreneurship
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
